module.exports = __webpack_public_path__ + "static/img/7.d7f3730.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/7.jpg
// module id = 3tyn
// module chunks = 16